import React, { useState } from 'react'
import { Post } from '../../web_api/api'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'

export default function TreatmentCreate() {
    const [name, setName] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [image, setImage] = useState([])
    const [type, setType] = useState('')
    const [addSection, setAddSection] = useState([])

    const [showNextSection, setShowNextSection] = useState(false)
    const [showNextImage, setShowNextImage] = useState(false)

    //NOTE Input Changes when input values
    const handleInputChange = (event, id, field) => {
        const newData = addSection.map(data => {
            if (data.id === id) {
                return { ...data, [field]: event.target.value }
            }
            return data
        })

        // const imgData = image.map(data => {
        //     if (data.id === id) {
        //         return { ...data, [field]: event.target.files[0] }
        //     }
        //     return data
        // })
        console.log(newData, 'new')
        setAddSection(newData)
        // setImage(imgData)
    }



    const AddSection = () => {

        setAddSection([
            ...addSection,
            {
                id: addSection.length + 1,
                title: title,
                description: description
            }
        ])

        // console.log(proMedName, 'pro med')
        setShowNextSection(true)
    }

    //to save image file in array that we click
    const ImageAddSection = (e) => {

        setImage([
            ...image,
            {
                id: image.length + 1,
                blog: e.target.files[0],

            }
        ])

        // console.log(proMedName, 'pro med')
        setShowNextImage(true)
    }

    const create = async () => {

        const sectionData = JSON.stringify(addSection)
        console.log(image, 'create')
        const formData = new FormData()
        formData.append('type', type)
        formData.append('name', name)
        image.map((item) => (
            formData.append('blog', item.blog)
        ))
        // formData.append('blog', image)
        formData.append('datas', sectionData)
        if (image.length !== addSection.length) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                // showCancelButton: true,

                showConfirmButton: false,
                timer: 2000
            })
        } else {
            const createTreatment = await Post('/blog', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            // console.log(createTreatment, 'createTreatment')
        }

    }
    return (
        <div>
            <div>
                <div>
                    <label for='#tn'>Treatment Name</label>
                    <input type='text' id='tn' placeholder='Teatment Name' className='form-control' onChange={(e) => setName(e.target.value)} />
                </div>
                <div>
                    <label for='#tn'>Treatment Type</label>
                    <select className='form-control' onChange={(e) => setType(e.target.value)}>
                        <option hidden>Choose Type ...</option>
                        <option value='face'>Face & Skin</option>
                        <option value='body'>Body Contouring </option>
                        <option value='dental'>Dental Care</option>
                    </select>
                </div>

                {showNextSection ? (
                    <>
                        {addSection.map((item, index) => (
                            <div className='border-1 border-info rounded-1 border p-3 mt-2'>
                                <h3 className='text-decoration-underline'>Tretment Detail Section {index + 1}</h3>
                                <div>
                                    <label for='#tn'>Title </label>
                                    <input type='text' id='tn' placeholder='Title' className='form-control' onChange={(e) => handleInputChange(e, item.id, 'title')} />
                                </div>
                                <div className=''>
                                    <label for='#tn' className={(image.length !== addSection.length) ? 'text-red' : ''}>Image </label>
                                    <input type='file' id='tn' className='form-control' onChange={(e) => ImageAddSection(e)} />
                                </div>
                                <div>
                                    <label for='#tn'>Description </label>
                                    <textarea type='text' id='tn' placeholder='Write description ...' className='form-control' onChange={(e) => handleInputChange(e, item.id, 'description')} />
                                </div>
                                {/* <div className='border-2 border-dark w-75 h-25'></div> */}
                            </div>
                        ))}
                    </>
                ) : (
                    <h3 className='mt-4'>Tretment Detail Section</h3>
                )}

                <div className='mt-3'>
                    <button className='btn btn-sm btn-primary rounded-2' onClick={AddSection}>Add Section</button>
                </div>
            </div>
            {/* Footer Button */}
            <div className='mt-3 text-center '>
                <Link to='/treatment-dashboard' className='btn btn-sm btn-default text-red rounded-2  ' >Cancel</Link>
                <button className='btn btn-sm btn-success rounded-2 ml-2 ' onClick={create}>Create</button>
            </div>
        </div>
    )
}
